export default [
  {
    id: 1,
    DayMonYear: 'Fri, Jan 10, 2025',
    memberAvatar: "",
    memberName: "Ava Smith", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Active", 
    role: "Organization owner",  
    projects: ["SG", "PQ", "CB", "CB"],  
    payment: 'Bill rate: No bill rate',
    limits: '45:00 / week',
    timeTrackingStatus: 'Enabled',
    dateAdded: 'Fri, Jan 10, 2025',
  },
   {
    id: 2,
    DayMonYear: 'Fri, Jan 11, 2025',
    memberAvatar: "https://i.pravatar.cc/150?img=3",
    memberName: "Devon Lane", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Active", 
    role: "Organization owner",  
    projects: ["SG", "PQ", "CB", "CB"],  
    payment: 'Bill rate: No bill rate',
    limits: '45:00 / week',
    timeTrackingStatus: 'Enabled',
    dateAdded: 'Fri, Jan 10, 2025',
  },
   {
    id: 3,
    DayMonYear: 'Fri, Jan 12, 2025',
    memberAvatar: "https://i.pravatar.cc/150?img=4",
    memberName: "Devon", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Active", 
    role: "Organization owner",  
    projects: ["SG", "PQ", "CB", "CB"],  
    payment: 'Bill rate: No bill rate',
    limits: '45:00 / week',
    timeTrackingStatus: 'Disabled',
    dateAdded: 'Fri, Jan 10, 2025',
  },
   {
    id: 4,
    DayMonYear: 'Fri, Jan 12, 2025',
    memberAvatar: "https://i.pravatar.cc/150?img=4",
    memberName: "Devon Sg", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Pending", 
    role: "Organization owner",  
    projects: ["SG", "PQ", "CB", "CB"],  
    payment: 'Bill rate: No bill rate',
    limits: '45:00 / week',
    timeTrackingStatus: 'Disabled',
    dateAdded: 'Fri, Jan 10, 2025',
  },
   {
    id: 5,
    DayMonYear: 'Fri, Jan 15, 2025',
    memberAvatar: "https://i.pravatar.cc/150?img=4",
    memberName: "Devon Sg", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Expired", 
    role: "Organization owner",  
    projects: ["SG", "PQ", "CB", "CB"],  
    payment: 'Bill rate: No bill rate',
    limits: '45:00 / week',
    timeTrackingStatus: 'Disabled',
    dateAdded: 'Fri, Jan 10, 2025',
  },
];
